<template>
    <div class="row">
        <div class="col col-12" style="padding-top:20px;padding-bottom:20px;">
            <div class="form-group">
                <label v-html="prompt"></label>
                <select class="form-control" id="feature-tie" v-model="BlockProps[propertyname]">
                    <option value="None" selected>None</option>
                    <option value="Apostille">Apostille</option>
                    <option value="CourierDelivery">Courier</option>
                    <option value="FieldInspection">Field Inspection</option>
                    <option value="RONNotarization">Remote Online Notarization</option>
                    <option value="FieldNotarization">In-Person Mobile Notarization</option>
                </select>
                <label class="text-muted fs-6 fst-italic">Tying a page block to a feature makes it disappear from your website if you disable that feature in your <a class="link" href="https://admin.notarylaunchpad.com/home/sitesettings" target="_blank">Admin Control Panel</a>. Blocks are automatically tied to a feature if they live inside of a particular feature's page, i.e. the Apostille Page, etc.</label>
            </div>

        </div>
        <hr style="margin-top: 10px; margin-bottom:5px;" />
    </div>
</template>

<style>
</style>




<script>
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: 'propertyfeaturetieeditor',
        emits: [],
        components: { },
        props: [
            "blockprops",
            "propertyname",
            "prompt"
        ],
        data() {
            return {    
                uid: ''
            };
        },
        methods:
        {      
          
        },
        computed:
        {
            BlockProps: function(){
                return this.blockprops;
            }
        },
        beforeMount: function () {

        },
        mounted: function () {
            this.uid = uuidv4();
        },
        beforeUnmount: function () {

        }
    }
</script>
